export default (Vue) => {
  Vue.component('countdown', () => import('./countdown/countdown'))
  Vue.component('modal', () => import('./modal/modal'))
  Vue.component('mbvodal', () => import('./mbvodal/mbvodal'))
  Vue.component('maps', () => import('./maps/map.vue'))
  Vue.component('card-add', () => import('./card-add'))
  Vue.component('page', () => import('./page/page'))
  Vue.component('pagefull', () => import('./pagefull'))
  Vue.component('pagination', () => import('./pagination/pagination'))
  Vue.component('medibook-select', () => import('./select/select'))
  Vue.component('spinner', () => import('./spinner'))
  Vue.component('card-step', () => import('./card-step'))
  Vue.component('medibook-alert', () => import('./medibook/alert'))
  Vue.component('medibook-delete', () => import('./medibook/delete'))
  Vue.component('medibook-success', () => import('./medibook/success'))
  Vue.component('medibook-alert-error', () => import('./medibook/error'))
  Vue.component('medibook-included', () => import('./medibook/included'))
  Vue.component('medibook-alert-custom', () => import('./medibook/custom'))
  Vue.component('medibook-alert-custom-slot', () => import('./medibook/custom-slot'))
  // Vue.component('carousel-control', () => import('./carousel/carousel-control'))
  // Vue.component('carousel', () => import('./carousel/carousel'))
  // Vue.component('carousel-item', () => import('./carousel/carousel-item'))
}



// WEBPACK FOOTER //
// ./src/components/root/index.js